import { useState } from "react";
import { useTranslation } from "react-i18next";

import "./style.scss";

const ConsentCheckbox = ({ onConsentChange, hasError = false }) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    if (onConsentChange) {
      onConsentChange(checked);
    }
  };

  return (
    <label className="custom-checkbox">
      <input
        name="consent"
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <span
        className={`checkmark ${isChecked ? "checked" : ""} ${hasError ? "error" : ""}`}
      ></span>
      <span className={`consent-text ${hasError ? "error" : ""}`}>
        {t("consent_checkbox_text1")}
        <br />
        {t("consent_checkbox_text2")}
        <a
          href="https://www.skedy.life/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("terms")}
        </a>
        {t("end")}
        <a
          href="https://www.skedy.life/policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("privacy_policy")}
        </a>
      </span>
    </label>
  );
};

export default ConsentCheckbox;
